import { Button, Stack, SxProps, Theme } from '@mui/material';

import { caloTheme } from '../../../../assets/themes/calo';

interface FilterButtonsProps {
  onClearFilters: () => void;
  onApplyFilters: () => void;
  clearButtonStyles?: SxProps<Theme> | undefined;
  applyButtonStyles?: SxProps<Theme> | undefined;
}

export default function FilterButtons({
  clearButtonStyles,
  applyButtonStyles,
  onApplyFilters,
  onClearFilters
}: FilterButtonsProps) {
  return (
    <Stack
      direction={'row'}
      spacing={2}
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }}
    >
      <Button variant="outlined" sx={{ ...clearButtonStyles, width: '50%' }} onClick={onClearFilters}>
        clear filter
      </Button>
      <Button
        variant="contained"
        sx={{ ...applyButtonStyles, color: caloTheme.palette.white, width: '50%' }}
        onClick={onApplyFilters}
      >
        apply
      </Button>
    </Stack>
  );
}
